export const useApi = async (
  path: string,
  options: {
    method?:
      | 'GET'
      | 'POST'
      | 'PUT'
      | 'DELETE'
      | 'PATCH'
      | 'HEAD'
      | 'OPTIONS'
      | 'CONNECT'
      | 'TRACE'
    body?: any
    query?: Record<string, any>
  } = {}
) => {
  try {
    const response = await $fetch(`/api/${path}`, {
      method: options.method ?? 'GET', // ✅ Correctly typed
      body: options.body,
      params: options.query
    })

    return response
  } catch (err) {
    console.error('API Error:', (err as Error).message)
    return null
  }
}
